import { useProfiles } from "../../../../context/ProfilesProvider";
import DashCard from "../../dashboard/DashCard";
import { formatDate, parseDate } from "../../broadcasters/community/format";

// The tipper's linked Chaturbate account, on their home page.
const CBProfileWidget = ({ broadcaster }: { broadcaster: string }) => {
  const { cbProfile, cbLoading } = useProfiles();
  if (cbLoading || !cbProfile) {
    return null;
  }
  const stream = `https://chaturbate.com/${broadcaster}/`;
  return (
    <DashCard
      title="Chaturbate"
      aside={
        <a
          href={stream}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-warning btn-sm"
        >
          Go to stream
        </a>
      }
    >
      <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
        <span className="text-lg font-semibold text-warning break-all">
          {cbProfile.username}
        </span>
        {cbProfile.inFanclub && (
          <span className="badge badge-success badge-outline">fan club</span>
        )}
      </div>
      {parseDate(cbProfile.createdDatetime) && (
        <div className="text-xs text-base-content/60">
          On Chaturbate since {formatDate(cbProfile.createdDatetime)}
        </div>
      )}
    </DashCard>
  );
};

export default CBProfileWidget;
